import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width={19}
    height={19}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Union"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 12.5H18.5V6.5H12.5V0.5H6.5V6.5H0.5V12.5H6.5V18.5H12.5V12.5Z"
      fill="#222A5C"
    />
  </svg>,
  "IntegrationFilled"
);
